import clsx from "clsx";

import { Avatar, Tooltip } from "@smart/itops-sb-design-system-dom";

import {
  fieldComponentIcons,
  fieldComponentNames,
  fieldComponentTooltips,
} from "../constants";
import { FieldTemplate } from "../types";

type FieldComponentProps = FieldTemplate & {
  disabled?: boolean;
  isDragging?: boolean;
  delta?: {
    x: number;
    y: number;
  };
};

const FieldComponent = ({
  type,
  disabled,
  isDragging,
  delta,
}: FieldComponentProps) => {
  const dragOffsetX = delta?.x || 0;
  const tiltAngle = isDragging
    ? Math.min(Math.max(Number(dragOffsetX) / 20, -10), 10)
    : 0;

  return (
    <div
      style={{
        transform: `rotate(${tiltAngle}deg)`,
      }}
      className={clsx(
        "flex items-center gap-small px-[1.6rem] py-[0.4rem] rounded hover:bg-cyan-140",
        isDragging && "bg-cyan-140 shadow-modal cursor-grab",
        disabled && "opacity-50 cursor-not-allowed",
      )}
      aria-disabled={disabled}
      aria-selected={isDragging}
    >
      <Tooltip {...(fieldComponentTooltips[type] || {})} offsetBy={7}>
        <Avatar
          size={32}
          icon={fieldComponentIcons[type].name}
          bgColor={fieldComponentIcons[type].bgColor}
        />
      </Tooltip>
      <span className="text-ui font-semibold">{fieldComponentNames[type]}</span>
    </div>
  );
};

export { FieldComponent, FieldComponentProps };
